import * as ActionTypes from '../constants/ActionTypes';

const messageState = {
  messageStatus: 'none',
  message: '',
};

export function systemMessage(state = messageState, action) {
  switch(action.type) {
    case ActionTypes.SET_MESSAGE:
      return Object.assign({}, state, {
        messageStatus: action.messageStatus,
        message: action.message,
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/systemMessage.js